var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 22.5C44 34.3741 34.3741 44 22.5 44C10.6259 44 1 34.3741 1 22.5C1 10.6259 10.6259 1 22.5 1C34.3741 1 44 10.6259 44 22.5Z",
    stroke: "#F4F4F4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.904 19.1552C27.4674 19.1552 27.924 18.6986 27.924 18.1352C27.924 17.5719 27.4674 17.1152 26.904 17.1152C26.3407 17.1152 25.884 17.5719 25.884 18.1352C25.884 18.6986 26.3407 19.1552 26.904 19.1552Z",
    fill: "url(#paint0_linear_315_3045)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 22.5C18.25 24.8439 20.1561 26.75 22.5 26.75C24.8439 26.75 26.75 24.8439 26.75 22.5C26.75 20.1561 24.8439 18.25 22.5 18.25C20.1561 18.25 18.25 20.1561 18.25 22.5ZM20.375 22.5C20.375 21.3281 21.3281 20.375 22.5 20.375C23.6719 20.375 24.625 21.3281 24.625 22.5C24.625 23.6719 23.6719 24.625 22.5 24.625C21.3281 24.625 20.375 23.6719 20.375 22.5Z",
    fill: "url(#paint1_linear_315_3045)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 31H26.75C28.9345 31 31 28.9345 31 26.75V18.25C31 16.0655 28.9345 14 26.75 14H18.25C16.0655 14 14 16.0655 14 18.25V26.75C14 28.9345 16.0655 31 18.25 31ZM16.125 18.25C16.125 17.2566 17.2566 16.125 18.25 16.125H26.75C27.7434 16.125 28.875 17.2566 28.875 18.25V26.75C28.875 27.7434 27.7434 28.875 26.75 28.875H18.25C17.2374 28.875 16.125 27.7626 16.125 26.75V18.25Z",
    fill: "url(#paint2_linear_315_3045)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_315_3045",
    x1: 26.2763,
    y1: 16.9583,
    x2: 27.6886,
    y2: 19.8614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB4CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_315_3045",
    x1: 19.8846,
    y1: 17.5962,
    x2: 25.7692,
    y2: 29.6923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB4CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_315_3045",
    x1: 17.2692,
    y1: 12.6923,
    x2: 29.0385,
    y2: 36.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB4CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB738"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.a54fad8bca0f3a182c8573a10954e69f.svg";
export { ForwardRef as ReactComponent };